import React, { useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'

const SearchSection = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const isMobile = useMediaQuery({ query: `(max-width: 639px)` })
  const navigate = useNavigate()

  const handleInputChange = (e) => {
    const value = e.target.value
    setSearchTerm(value)

    if (value === '') {
      navigate('/')
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const cleanTerm = searchTerm.trim()

    if (!cleanTerm) {
      navigate('/')
      return
    }

    // 🚀 Sends search to Home route via URL
    navigate(`/?search=${encodeURIComponent(cleanTerm)}`)
  }

  return (
    <div className="flex-1 flex h-full justify-center">
      {!isMobile ? (
        <form 
          onSubmit={handleSubmit}
          className="w-3/4 lg:w-1/2 z-20 ring-2 ring-gray-400 bg-gray-200 h-8 self-center rounded-2xl flex"
        >
          <div className="flex-1">
            <input
              id="video-search"
              name="video-search"
              type="text"
              value={searchTerm}
              onChange={handleInputChange}
              placeholder="Search here..."
              className="w-full px-4 z-10 rounded-l-2xl h-full text-black outline-none bg-white text-sm"
            />
          </div>
          <button 
            type="submit" 
            className="px-6 rounded-r-2xl border-l-2 border-gray-400 h-full hover:bg-gray-300 transition-colors flex items-center justify-center"
          >
            <i className="fa-sharp fa-solid fa-magnifying-glass text-lg text-black"></i>
          </button>
        </form>
      ) : null}
    </div>
  )
}

export default SearchSection
